import { render, staticRenderFns } from "./alarmTypeCard.vue?vue&type=template&id=5d23f901&"
import script from "./alarmTypeCard.vue?vue&type=script&lang=js&"
export * from "./alarmTypeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports